import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="font-sans bg-ink text-white">
      {/* Hero Section */}
      <section className="panel-surface text-white section-padding font-display">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-display font-bold mb-6">
            Terms of Use
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto font-sans">
            Please read these terms carefully before using IBT Sports services and platforms.
          </p>
          <div className="mt-6">
            <div className="badge-official">Last Updated: December 2024</div>
          </div>
        </div>
      </section>

      {/* Policy Content */}
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          <div className="space-y-12">
            
            {/* Introduction */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Agreement to Terms
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Services Description */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Our Services
              </h2>
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-gradient-to-br from-primary to-accent-warm rounded-lg flex items-center justify-center mr-4 mt-1">
                        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2 6a2 2 0 012-2h6l2 2h6a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"/>
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white font-display">Sports Streaming</h4>
                        <p className="text-sm text-gray-300 font-sans">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-gradient-to-br from-accent-warm to-primary rounded-lg flex items-center justify-center mr-4 mt-1">
                        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white font-display">Mobile Applications</h4>
                        <p className="text-sm text-gray-300 font-sans">Ut enim ad minim veniam, quis nostrud exercitation.</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-gradient-to-br from-accent-success to-primary rounded-lg flex items-center justify-center mr-4 mt-1">
                        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white font-display">Premium Content</h4>
                        <p className="text-sm text-gray-300 font-sans">Duis aute irure dolor in reprehenderit in voluptate.</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-gradient-to-br from-primary to-accent-success rounded-lg flex items-center justify-center mr-4 mt-1">
                        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white font-display">Customer Support</h4>
                        <p className="text-sm text-gray-300 font-sans">Excepteur sint occaecat cupidatat non proident.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* User Accounts */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                User Accounts and Registration
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-4 font-display">Account Creation</h3>
                  <div className="space-y-3 text-gray-300 font-sans">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. To use our services, you must:</p>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Be at least 18 years old or have parental consent
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Provide accurate and complete information
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Maintain the security of your account credentials
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                        Accept responsibility for all activities under your account
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-white mb-4 font-display">Account Responsibilities</h3>
                  <div className="space-y-3 text-gray-300 font-sans">
                    <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua:</p>
                    <ul className="space-y-2 ml-6">
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                        Notify us immediately of any unauthorized use
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                        Keep your contact information up to date
                      </li>
                      <li className="flex items-start">
                        <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                        Comply with all applicable laws and regulations
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Acceptable Use */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Acceptable Use Policy
              </h2>
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-4 font-display">Permitted Uses</h3>
                    <div className="space-y-3 text-gray-300 font-sans">
                      <ul className="space-y-2 ml-6">
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-accent-success rounded-full mr-3 mt-2"></div>
                          Personal, non-commercial streaming
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-accent-success rounded-full mr-3 mt-2"></div>
                          Sharing with family members
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-accent-success rounded-full mr-3 mt-2"></div>
                          Educational purposes
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-4 font-display">Prohibited Uses</h3>
                    <div className="space-y-3 text-gray-300 font-sans">
                      <ul className="space-y-2 ml-6">
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                          Commercial redistribution
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                          Reverse engineering
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                          Circumventing security measures
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment Terms */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Payment and Subscription Terms
              </h2>
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {[
                    { title: "Billing", desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
                    { title: "Refunds", desc: "Sed do eiusmod tempor incididunt ut labore et dolore." },
                    { title: "Cancellation", desc: "Ut enim ad minim veniam, quis nostrud exercitation." }
                  ].map((term, index) => (
                    <div key={index} className="panel-surface p-6 rounded-lg">
                      <h4 className="font-semibold text-white mb-2 font-display">{term.title}</h4>
                      <p className="text-sm text-gray-300 font-sans">{term.desc}</p>
                    </div>
                  ))}
                </div>
                <div className="space-y-4 text-gray-300 font-sans">
                  <p>
                    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                  </p>
                </div>
              </div>
            </div>

            {/* Intellectual Property */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Intellectual Property Rights
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Limitation of Liability */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Limitation of Liability
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Termination */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Termination
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Contact Us
              </h2>
              <div className="space-y-4 text-gray-300 font-sans">
                <p>
                  If you have any questions about these Terms of Use, please contact us:
                </p>
                <div className="space-y-2">
                  <p><strong className="text-white">Email:</strong> legal@ibtsports.com</p>
                  <p><strong className="text-white">Phone:</strong> +1 (800) IBT-SPORT</p>
                  <p><strong className="text-white">Address:</strong> 123 Sports Avenue, Suite 500, New York, NY 10001</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfUse;
